import React from 'react';
import { motion } from 'framer-motion';
import PageHero from '../components/PageHero';
import Contact from '../components/Contact';

const pageVariants = {
  initial: { opacity: 0, x: 40 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -40 },
};

const ContactPage = () => (
  <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit" transition={{ duration: 0.35 }}>
    <PageHero
      title="Get In"
      highlight="Touch"
      subtitle="Feel free to reach out for opportunities, collaborations, or just to say hello. I usually respond within 24 hours."
      pattern="dots"
    />
    <Contact hideTitle />
  </motion.div>
);

export default ContactPage;
